module.exports = __webpack_public_path__ + "img/american-express.81b2d3c1.png";